module.exports = __webpack_public_path__ + "img/cultureClose3.31541ec3.png";